<template>
  <div class="product-donate-duration-wrapper" v-if="visible">
    <div class="duration-heading">{{ headingLabel }}</div>
    <fieldset class="sr-only-legend-wrapper">
      <legend class="sr-only">{{ headingLabel }}</legend>
      <div class="product-donate-duration">
        <div v-for="opt in options" :key="opt.value" class="donate-duration-item">
          <div class="control">
            <input
              :id="`duration-${opt.value}`"
              type="radio"
              name="donation_duration"
              v-model.number="selected"
              :value="opt.value"
            />
            <label
              :for="`duration-${opt.value}`"
              class="label"
              :class="{ 'label--selected': selected === opt.value }"
            >
              {{ opt.label }}
            </label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
  // Phase 10 donor-facing duration pill selector.
  // Labels are hardcoded JS constants (T-10-23 XSS mitigation — never donor-controlled).
  const MONTHLY_LABELS = { 3: '3 เดือน', 6: '6 เดือน', 12: '12 เดือน', 0: 'ไม่กำหนด' }
  const DAILY_LABELS = { 3: '3 วัน', 7: '7 วัน', 14: '14 วัน', 0: 'ไม่กำหนด' }

  export default {
    name: 'ProductDuration',

    props: {
      product: {
        type: Object,
        default: null
      },
      donateType: {
        type: String,
        default: 'monthly'
      },
      value: {
        type: Number,
        default: 0
      }
    },

    data () {
      return {
        selected: this.value || 0
      }
    },

    computed: {
      headingLabel () {
        return this.donateType === 'daily' ? 'จำนวนวัน' : 'จำนวนเดือน'
      },
      // Default-ON per D-18: absent meta or any truthy value => enabled; only explicit "false" disables.
      allowCustomDuration () {
        if (!this.product || !this.product.meta) return true
        const v = this.product.meta['$donation_custom_duration']
        return v !== false && v !== 'false'
      },
      optionValues () {
        if (!this.product) return []
        if (this.donateType === 'daily') return this.product.duration_options_daily || []
        if (this.donateType === 'monthly') return this.product.duration_options_monthly || []
        return []
      },
      options () {
        const labels = this.donateType === 'daily' ? DAILY_LABELS : MONTHLY_LABELS
        return this.optionValues.map(v => ({
          value: Number(v),
          label: labels[Number(v)] || String(v)
        }))
      },
      visible () {
        if (!this.product) return false
        if (this.donateType !== 'monthly' && this.donateType !== 'daily') return false
        if (!this.allowCustomDuration) return false
        if (this.options.length === 0) return false
        return true
      }
    },

    watch: {
      selected (v) {
        this.$emit('input', v)
      },
      value (v) {
        this.selected = v
      }
    }
  }
</script>

<style scoped lang="scss">
  .product-donate-duration-wrapper {
    margin-top: 8px;
    margin-bottom: 20px;
  }

  .duration-heading {
    font-family: 'Wittaya-Medium', Thonburi, Arial, sans-serif;
    font-size: 1.15rem;
    color: #153050;
    margin-bottom: 0.5rem;
    @media only screen and (min-width: 768px) {
      font-size: 1.35rem;
    }
  }

  .sr-only-legend-wrapper {
    border: 0;
    padding: 0;
    margin: 0;
  }

  .sr-only {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .product-donate-duration {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
    padding: 0;
  }

  .donate-duration-item {
    .control {
      position: relative;

      input[type="radio"] {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
        opacity: 0;
        cursor: pointer;
      }

      .label {
        min-height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 8px;
        cursor: pointer;
        color: #153050;
        background: #ffffff;
        border: 1px solid rgba(21, 48, 80, 0.15);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        font-weight: 400;
        font-size: 1rem;
        font-family: 'Wittaya-Medium', Thonburi, Arial, sans-serif;
        transition: border-color 0.2s, background 0.2s, color 0.2s;
        margin-bottom: 0;
        padding: 0.25rem;

        @media only screen and (min-width: 768px) {
          font-size: 1.15rem;
        }
      }

      input[type="radio"]:checked + .label,
      .label.label--selected {
        background: #FFF6EC;
        color: #153050;
        border: 2px solid #F4A33F;
        font-weight: 700;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductDuration.vue?40e5e063